// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1xmSf","content":"LayoutSettings_content__1eZO3"};